import React from "react";

export const NotFoundLayout = (props) => {
  return <div>{props.children}</div>;
};

export default NotFoundLayout;
